import { render, staticRenderFns } from "./TypeCreateOrUpdate.vue?vue&type=template&id=3b8cfb79&"
import script from "./TypeCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./TypeCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports